import { render, staticRenderFns } from "./vendor_admin_panel.vue?vue&type=template&id=bfd3cac0"
import script from "./vendor_admin_panel.vue?vue&type=script&lang=js"
export * from "./vendor_admin_panel.vue?vue&type=script&lang=js"
import style0 from "./vendor_admin_panel.vue?vue&type=style&index=0&id=bfd3cac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports